import { Store } from 'pullstate'

const DashboardStore = new Store({ });

export default DashboardStore;